export const basename = process.env.PUBLIC_URL || "";
